import React from "react";
import ItemVisibilitySettings from "fantastic/components/common/controls/ItemVisibilitySettings";
import ItemVisibilityConditionsSettings from "fantastic/components/common/controls/ItemVisibilityConditionsSettings";

export default ({ onChange, node, recipientParameters }) => {
  const visibilityParams = {
    onChange,
    scrollToIfNeeded: () => {},
    visible: {
      field: 'show',
      value: node.show || ''
    }
  };

  const visibilityConditionsParams = {
    recipientParameters,
    onChange,
    scrollToIfNeeded: () => {},

    conditionsGroupLogical: {
      field: 'visibility_conditions_group_logical',
      value: node.visibility_conditions_group_logical || 'and'
    },
    conditions: {
      field: 'visibility_conditions',
      value: node.visibility_conditions || []
    }
  };

  return (
    <>
      <label>{ i18n.t('display_conditions') }</label>
      <div>
        <ItemVisibilityConditionsSettings {...visibilityConditionsParams} />
      </div>
      <label>{ i18n.t('device_types') }</label>
      <div>
        <ItemVisibilitySettings {...visibilityParams} />
      </div>
    </>
  );
};
